// extracted by mini-css-extract-plugin
export default {"public-layout":"public-layout","content-box":"content-box","transparent":"transparent","content-header":"content-header","content-body":"content-body","login-text-detail":"login-text-detail","login-detail-text":"login-detail-text","loading-animation-wrapper":"loading-animation-wrapper","loading-animation":"loading-animation"};
    if(module.hot) {
      // 1790857657231
      var cssReload = require("/home/vsts/work/1/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  